import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const TEAMHIL = () => {
    return (
        <section className='TEAMHIL'>
            <MatchTable betType='TEAMHIL' etBetType="TEAMEHL" />
            <Remark />
        </section>
    )
}
export default TEAMHIL;